export default "__VITE_ASSET__AbXWwcsY__"